
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[addressOrSlug]",
      function () {
        return require("private-next-pages/collection/[addressOrSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/[addressOrSlug]"])
      });
    }
  